import { Component, Input } from '@angular/core'
import { WebsitePreviewItemContext } from './ibranson-preview.iface'

@Component({
  selector: 'app-ib-overview',
  templateUrl: './ib-overview.component.html',
  standalone: false,
})
export class IbOverviewComponent {
  @Input() item: WebsitePreviewItemContext = {}
  showFull = false

  get descriptionHtml(): string {
    return this.item.description || ''
  }

  get descriptionText(): string {
    return this.descriptionHtml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
  }

  get shortDescription(): string {
    const text = this.descriptionText
    if (text.length <= 220) {
      return text
    }
    return text.slice(0, 220).trim() + '...'
  }

  get canToggle(): boolean {
    return this.descriptionText.length > 220
  }

  toggle(event: Event) {
    event.preventDefault()
    this.showFull = !this.showFull
  }
}
